const config = {
  zendeskApi: 'https://labelinsight.zendesk.com/api',
  pendoApi: 'https://app.pendo.io/api/v1',
  pendoApiHeaders: {
    'Content-Type': 'application/json',
    'X-Pendo-Integration-Key': '1aa26363-e289-42b0-6e13-7a6011944fe0',
  },
  featureFlags: {},
  restrictedApplications: ['capture', 'publish', 'explore', 'explore-specs'],
  applicationConfigurations: {
    default: {
      marketingLink: 'https://www.labelinsight.com/solutions',
    },
    onboard: {
      name: 'Onboard',
      description: `Add products and images to your organization, resolve any onboarding issues, and access your image and product libraries`,
    },
    capture: {
      name: 'Capture',
      description: 'Access and export your LI Capture product images',
      marketingDescription: `Capture is a premium part of Label Insight's offering that simplifies the ecosystem by providing a single source of high-quality product images connected to complete product attribute data.`,
      marketingLink: `https://www.labelinsight.com/i-want-solutions-for-images-data`,
    },
    publish: {
      name: 'Publish',
      description: 'Review, update, and publish your SmartLabel™ pages',
      marketingDescription: `Publish is a premium part of our LabelSync offering that lets you review and add data for your SmartLabel pages.`,
    },
    explore: {
      name: 'Explore',
      description: `Search, view, and compare your organization's products across the marketplace`,
      marketingDescription: `Explore is a premium part of Label Insight's offering that lets you search, view product details, and compare across products.`,
    },
    get 'explore-specs'() {
      return this.explore
    },
  },
}

if (process.env.NODE_ENV === 'production') {
  Object.assign(config, {
    launchDarklyKey: '57d4aa4dbaa7ff071d230499',
    admin: 'https://external-api.labelinsight.com/admin-management-api/rest',
    applicationIds: {
      onboard: 3,
      capture: 4,
      publish: 5,
      explore: 6,
      exploreSpecs: 7,
      internalAdmin: 8,
      customerAdmin: 2,
    },
  })
} else {
  Object.assign(config, {
    launchDarklyKey: '57d4aa4dbaa7ff071d230498',
    admin: `https://dev-external-api.labelinsight.com/admin-management-api/rest`,
    applicationIds: {
      onboard: 3,
      capture: 4,
      publish: 5,
      explore: 6,
      exploreSpecs: 7,
      internalAdmin: 8,
      customerAdmin: 16,
    },
  })
}

export default config



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/config.js